import * as React from "react";
import { ChakraProvider, defaultSystem } from "@chakra-ui/react";
import system from "./src/theme"; // se não criou, troque por defaultSystem

export const wrapRootElement = ({ element }: { element: React.ReactNode }) => (
  <ChakraProvider value={system ?? defaultSystem}>{element}</ChakraProvider>
);
